import { render, staticRenderFns } from "./BulletBlock.vue?vue&type=template&id=97568c6e&scoped=true"
import script from "./BulletBlock.vue?vue&type=script&lang=js"
export * from "./BulletBlock.vue?vue&type=script&lang=js"
import style0 from "./BulletBlock.vue?vue&type=style&index=0&id=97568c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97568c6e",
  null
  
)

export default component.exports